<div [class.d-flex]="reverse" [class.reverse]="reverse" [class.event-master-gold-color]="gold">
	<fa-icon [icon]="['fas', icon]" *ngIf="showIcon && !showLabel" size="large ? '2x' : ''" class="vertical-center" placement="bottom" ngbTooltip="{{ name }} {{ notes ? ' - ' + notes : '' }}"></fa-icon>
	<fa-icon [icon]="['fas', icon]" *ngIf="showIcon && showLabel" size="large ? '2x' : ''" class="vertical-center" [class.has-label]="showLabel"></fa-icon>
	<h6 *ngIf="!large && showLabel">{{ name }}</h6>
	<h5 *ngIf="large && showLabel" class="vertical-center">{{ name }}</h5>
</div>
